













































































































































































































































































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  ArenaSignSignerRoleConfigurationModel,
  ArenaSignSignerRoleDataFieldModel,
  ArenaSignSignerRoleDataSourceModel,
  ArenaSignSignerRoleCreateUpdateModel,
  ArenaSignAuthenticationTypes
} from '@/types';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
export default Vue.extend({
  name: 'ArenaSignUpdateSignerRole',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    submitIsLoading: {
      type: Boolean,
      required: true
    },
    signerRoleConfiguration: {
      type: Object as () => ArenaSignSignerRoleConfigurationModel,
      required: true,
      default: {} as ArenaSignSignerRoleConfigurationModel
    },
    signerRole: {
      type: Object as () => ArenaSignSignerRoleCreateUpdateModel,
      required: true,
      default: {} as ArenaSignSignerRoleCreateUpdateModel
    },
    serverValidationMessage: {
      type: String,
      required: true
    },
    authenticationTypes: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        if (
          !this.validateNamePrePopulation() ||
          !this.validateEmailAddressPrePopulation() ||
          !this.validateNameAndEmailAddressList() ||
          !this.validateMobileNumberPrePopulation()
        ) {
          return;
        }
        this.$emit('submit', this.signerRole);
      } catch (error) {
        this.$log('Error updating signer role', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    onCancel(this: any) {
      this.$emit('on-cancel-clicked', this.documentTypeId);
    },
    selectedDataSourceFields(dataSourceKey: string): ArenaSignSignerRoleDataFieldModel[] {
      if (
        !dataSourceKey ||
        !this.signerRoleConfiguration ||
        !this.signerRoleConfiguration.signerRoleDataSources ||
        !this.signerRole
      ) {
        return [] as ArenaSignSignerRoleDataFieldModel[];
      }
      const selectedDataSource:
        | ArenaSignSignerRoleDataSourceModel
        | undefined = this.signerRoleConfiguration.signerRoleDataSources.find((x) => x.key === dataSourceKey);
      if (!selectedDataSource) {
        return [] as ArenaSignSignerRoleDataFieldModel[];
      }
      return selectedDataSource.fields;
    },
    validateNamePrePopulation(this: any): boolean {
      this.resetFormValidation();
      if (!this.signerRole.useDataSourceForName) {
        return true;
      }
      if (
        this.isNullOrEmpty(this.signerRole.nameDataSourceKey) ||
        this.isNullOrEmpty(this.signerRole.nameDataFieldKey)
      ) {
        this.addFormValidationError('Please select a data-source and data-field key for the name pre-population');
        return false;
      }
      return true;
    },
    validateEmailAddressPrePopulation(this: any): boolean {
      this.resetFormValidation();
      if (!this.signerRole.useDataSourceForEmailAddress) {
        return true;
      }
      if (
        this.isNullOrEmpty(this.signerRole.emailAddressDataSourceKey) ||
        this.isNullOrEmpty(this.signerRole.emailAddressDataFieldKey)
      ) {
        this.addFormValidationError(
          'Please select a data-source and data-field key for the email address pre-population'
        );
        return false;
      }
      return true;
    },
    validateMobileNumberPrePopulation(this: any): boolean {
      this.resetFormValidation();
      if (!this.signerRole.useDataSourceForMobile) {
        return true;
      }
      if (
        this.isNullOrEmpty(this.signerRole.mobileDataSourceKey) ||
        this.isNullOrEmpty(this.signerRole.mobileDataFieldKey)
      ) {
        this.addFormValidationError(
          'Please select a data-source and data-field key for the mobile number pre-population'
        );
        return false;
      }
      return true;
    },
    validateNameAndEmailAddressList(this: any): boolean {
      this.resetFormValidation();
      if (!this.signerRole.useListForNameAndEmailAddress) {
        return true;
      }
      if (this.signerRole.listId == null) {
        this.addFormValidationError('Please select a MAF list for the name and email address');
        return false;
      }
      return true;
    }
  },
  computed: {
    nameDataFieldList(): ArenaSignSignerRoleDataFieldModel[] {
      return this.signerRoleConfiguration.signerRoleDataSources[0].fields;
    },
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    serverFormValidationError(this: any) {
      if (!this.isNullOrEmpty(this.serverValidationMessage)) {
        this.addFormValidationError(this.serverValidationMessage);
      }
    },
    authenticationTypesExist(this: any) {
      return this.authenticationTypes.length > 1;
    },
    authenticationTypeIsSMS(this: any) {
      return this.signerRole.authenticationType === ArenaSignAuthenticationTypes.SMS;
    }
  },
  components: {
    MStoreFormSelect,
    LoadingSpinner
  }
});
